/**
 * Release date shown under the logo (top bar + login).
 * Primary: frontend/src/config/releaseDateStamp.ts — updated only by scripts/deploy-to-vps.sh.
 * Fallback: VITE_RELEASE_DATE at build time.
 */

import { RELEASE_DATE_STAMP } from './releaseDateStamp';

/**
 * @returns {string|null} e.g. "26.04.29" (yy.mm.dd), or null if not configured
 */
export function getReleaseDateRaw() {
  if (typeof RELEASE_DATE_STAMP === 'string') {
    const t = RELEASE_DATE_STAMP.trim();
    if (t) return t;
  }
  const v = import.meta.env.VITE_RELEASE_DATE;
  if (v == null || typeof v !== 'string') return null;
  const t = v.trim();
  return t || null;
}

/**
 * @returns {string|null} Label for UI, or null to hide the line
 */
export function getReleaseDateLabel() {
  return getReleaseDateRaw();
}
